import {Nullish} from 'shared/web';

import {EVALUATION_UNKNOWN_FLAG} from '../constants/evaluation';

export function getEvaluationFlagLabel(evaluation: string | Nullish): string {
  return evaluation || EVALUATION_UNKNOWN_FLAG;
}
